<template>
	<div id="Portability" class="col-12 col-tab-1">
		<div class="row justify-content-center">
			<div class="col-12">
				<h5 class="mb-0 tab-title">Cámbiate a BlackFon</h5>

				<p class="mb-2 text-center f-w-600">
					Realiza la solicitud de portabilidad aqui, siempre y cuando ya tengas una SIM o eSIM de BlackFon activa, normalmente el proceso se completa el siguiente dia hábil.
				</p>
			</div>

			<b-form class="row mt-3 justify-content-center limit-width" @submit="onSubmit">

				<b-form-group class="col-md-12 custom-f-group" label="* Tu nombre completo">
					<b-form-input v-model="form.nombre_completo" type="text" required placeholder="" :minlength="5" :maxlength="100"  />
				</b-form-group>

				<b-form-group class="col-md-6 col-lg-5 custom-f-group" label="*Número a portar (10 dígitos)">
					<b-form-input v-model="form.telefono" type="text" required placeholder="" :minlength="10" :maxlength="10" @keypress="$root.isNumber($event)" @paste="$root.noPaste"  />
				</b-form-group>

				<b-form-group class="col-md-5 col-lg-4 custom-f-group" label="NIP de Portabilidad">
					<b-form-input v-model="form.portacion_nip" type="text" required placeholder="" :minlength="3" :maxlength="6" @keypress="$root.isNumber($event)" @paste="$root.noPaste"  />
				</b-form-group>

				<hr>

				<b-form-group class="col-md-12 custom-f-group" label="* Número provisional BlackFon o ICCID (Serie de tu SIMo eSIM)">
					<b-form-input v-model="form.iccid_msisdn" type="text" required placeholder="" :minlength="10" :maxlength="20"  />
				</b-form-group>


				<div class="col-md-12 text-center mb-4">
					<p class="f-w-600" style="font-size: 1.10rem;">
						Los campos con * son obligatorios.
					</p>
					<p  class="f-w-600">
						Para obtener tu NIP de portabilidad llama al 051 desde el número que deseas portar.
					</p>
				</div>

				<div class="col-10 text-center">
					<b-button type="submit" class="btn-send btn-s2" v-if="!isProcessing">Enviar</b-button>
					<b-button type="submit" disabled class="btn-send btn-s2" v-else>Procesando...</b-button>
				</div>
			</b-form>

		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'Portability',
	data() {
		return {
			isProcessing: false,
			form: {
				nombre_completo: '',
				telefono: '',
				portacion_nip: '',
				iccid_msisdn: '',
			}
		}
	},

	methods: {
		...mapActions(['portabilidadProcess']),
		makeToast(variant = null, msg, title) {
			this.$bvToast.toast(msg, {
				title: title,
				variant: variant,
				solid: true,
				toaster: 'b-toaster-top-right',
				appendToast: true
			})
		},

		async onSubmit(event) {
			event.preventDefault();
			if (!this.isProcessing) {
				this.isProcessing = true;
				let response = await this.portabilidadProcess(this.form)
				if (response) {
					this.$router.replace('/portabilidad/enviado');
				} else {
					this.isProcessing = false;
				}
			} else {
				console.log('API Ocupada');
			}
		},
	}
}
</script>

<style lang="scss">
#Portability {
	.limit-width {
		max-width: 600px;
	}
}
</style>